module.exports = __webpack_public_path__ + "static/media/1.5ba68f98.JPG";